import { useEffect, useState } from 'react';
import { Grid } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import useTranslation from '../../localization/useTranslation';
import { isAuthenticated } from '../../utilities/authentication';
import { SUPPORT_CHAT_OPEN_EVENT, SUPPORT_CHAT_PATH } from '../../utilities/supportChat';
import SupportChatPanel from './SupportChatPanel';
import './SupportChatWidget.css';

const { useBreakpoint } = Grid;

const SupportChatWidget = () => {
  const { language } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  // Matches PrivateRoute: below lg the sidebar is a drawer and chat lives on its own page.
  const isMobile = screens.lg !== true;
  const authenticated = isAuthenticated();
  const onChatPage = location.pathname.replace(/\/$/, '').toLowerCase() === SUPPORT_CHAT_PATH;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onOpen = () => {
      if (isMobile) {
        navigate(SUPPORT_CHAT_PATH);
      } else if (!onChatPage) {
        setOpen(true);
      }
    };
    window.addEventListener(SUPPORT_CHAT_OPEN_EVENT, onOpen);
    return () => window.removeEventListener(SUPPORT_CHAT_OPEN_EVENT, onOpen);
  }, [isMobile, onChatPage, navigate]);

  useEffect(() => {
    if (isMobile || onChatPage) {
      setOpen(false);
    }
  }, [isMobile, onChatPage]);

  if (!authenticated || isMobile || onChatPage || !open) {
    return null;
  }

  return (
    <div className="support-chat support-chat--open" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <SupportChatPanel onClose={() => setOpen(false)} />
    </div>
  );
};

export default SupportChatWidget;
